module.exports = __webpack_public_path__ + "img/king-k-rool-min.f229f4bb.png";